export const blockIconsBusinessandpaymentsQrCode2New = (
	<span className='material-symbols-outlined'>qr_code_2</span>
);
